import styles from 'styles/components/aiSuggestionWrapper.module.scss';

const AiSuggestionWrapper = ({ children, loading }) => {
  return <div className={`${styles.aiSuggestionWrapper} ${loading ? styles.extraLoading : ''}`}>{children}</div>;
};

export default AiSuggestionWrapper;
